module.exports = __webpack_public_path__ + "onboarding-targettypes.ef0546559c030c4bd929aea1e3400a3a.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/style-guide/img/onboarding-targettypes.svg
// module id = 4326623779287835
// module chunks = 1